
  function selectPurchase(label) {
    document.querySelectorAll('.purchase-option').forEach(l => l.classList.remove('purchase-option-selected'));
    label.classList.add('purchase-option-selected');
    var radio = label.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;
  }

  function openNutrModal() {
    var m = document.getElementById('nutrModal');
    // src is set inline once CDN URL is known; fallback if empty
    var img = document.getElementById('nutrModalImg');
    if (!img.src || img.src === window.location.href) {
      img.src = 'https://cdn.shopify.com/s/files/1/0778/0391/3394/files/nutrition-facts.png';
    }
    m.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeNutrModal(e) {
    if (!e || e.target === document.getElementById('nutrModal') || e.target.classList.contains('nutr-modal-close')) {
      document.getElementById('nutrModal').classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  function toggleAcc(btn) {
    const body = btn.nextElementSibling;
    const isOpen = body.classList.contains('open');
    btn.classList.toggle('open', !isOpen);
    body.classList.toggle('open', !isOpen);
  }
  function showIng(idx, tab) {
    document.querySelectorAll('.ing-panel').forEach(p => p.classList.remove('active'));
    document.querySelectorAll('.ing-tab').forEach(t => t.classList.remove('active'));
    document.getElementById('ing-' + idx).classList.add('active');
    tab.classList.add('active');
  }
  function selectToggle(btn) {
    document.querySelectorAll('.toggle-option').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const isSubscribe = btn.querySelector('.to-save') !== null;
    const sub = document.getElementById('subBenefits');
    if (sub) sub.classList.toggle('visible', isSubscribe);
  }
  function swapHero(src, el) {
    document.getElementById('heroMainImg').src = src;
    document.querySelectorAll('.hero-thumb').forEach(t => t.classList.remove('active'));
    if (el) el.classList.add('active');
  }
  function handleEmail(e) {
    e.preventDefault();
    const btn = e.target.querySelector('button');
    btn.textContent = "You're in ✓";
    btn.style.background = '#1C3828';
  }

  // Countdown timer — sets deadline to 24h from first visit, stored in sessionStorage
  (function() {
    var key = 'settle_cd_end';
    var end = sessionStorage.getItem(key);
    if (!end) {
      end = Date.now() + 23 * 3600000 + 47 * 60000 + 12000;
      sessionStorage.setItem(key, end);
    }
    end = parseInt(end);
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) diff = 0;
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var pad = function(n) { return n < 10 ? '0' + n : '' + n; };
      var eh = document.getElementById('cd-h');
      var em = document.getElementById('cd-m');
      var es = document.getElementById('cd-s');
      if (eh) eh.textContent = pad(h);
      if (em) em.textContent = pad(m);
      if (es) es.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  })();

  // Show sub benefits by default (subscribe is pre-selected)
  document.addEventListener('DOMContentLoaded', function() {
    var sub = document.getElementById('subBenefits');
    if (sub) sub.classList.add('visible');
  });
